<div [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Company name</mat-label>
    <input formControlName="name" matInput placeholder="Company name">
    <mat-icon matSuffix svgIcon="company"></mat-icon>
  </mat-form-field>
</div>